import React, { useState, useEffect } from "react";
import { Table, Row, Col, Card, CardBody, CardTitle, Alert, Label, Input, Badge } from "reactstrap"
import Select from "react-select";
import { post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans, useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ITEMS_PER_PAGE } from "helpers/pagination_helper";
import Loader from "common/loader";
import { TASKS_SEARCH } from "helpers/api_endpoints";
import {DELIVERY_TYPE_SEARCH, DRIVER_TYPE_SEARCH} from "helpers/api_endpoints";
//meta title
document.title = "Tasks";
const TaskList = () => {
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [name, setName] = useState('');
    const [value, setValue] = useState('');
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(true);
    const [Tasks, setTasks] = useState([]);
    const [filters, setFilters] = useState({});
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [successMsg, setsuccessMsg] = useState('');
        const [deliveryTypes, setDeliveryTypes] = useState([]);
        const [driverTypes, setDriverTypes] = useState([]);
            const [deliveryTypeId, setDeliveryTypeId] = useState('');
            const [driverTypeId, setDriverTypeId] = useState('');

    // Helper function to get translated text based on current language
    const getTranslatedText = (titleArray, defaultText) => {
        const langMap = { 'en': 1, 'ar': 2, 'ur': 3, 'fa': 4, 'ps': 5 };
        const langKey = langMap[i18n.language] || 1;
        const titleObj = titleArray?.find(item => item[langKey]);
        return titleObj ? titleObj[langKey] : defaultText;
    };

    useEffect(() => {
        successMessage();
        post(`${TASKS_SEARCH}?paginate=${ITEMS_PER_PAGE}&page=${page}`, filters)
            .then(response => {
                const data = response.data;
                setTasks(data.data);
                setTotalPages(data.pagination.totalPages);
                setTotalItems(data.pagination.totalItems);
                setPage(data.pagination.currentPage);
                setLoading(false);
            })
            .catch(error => { console.log(error);
                // if (error.response.status == 400) {
                //     navigate('/logout');
                // }
            })
    }, [page, filters]);

    const successMessage = () => {
        if (location.state) {
            setsuccessMsg(location.state.successMsg);
            setTimeout(() => {
                location.state.successMessage = '';
                setsuccessMsg('');
            }, 4000)
        }
    };

        useEffect(() => {
            // successMessage();
            post(`${DELIVERY_TYPE_SEARCH}`)
                .then(response => {
                    const data = response.data.map((el,index)=>{
                        return {value:el.id,label:el.name}; 
                    });
                    setDeliveryTypes(data);
                    // setLoading(false);
                })
                .catch(error => {
                    console.log(error)
                    if (error.response.status == 400) {
                        navigate('/logout');
                    }
                })

                post(`${DRIVER_TYPE_SEARCH}`)
                            .then(response => {
                                const data = response.data.map((el,index)=>{
                                    return {value:el.id,label:el.name}; 
                                });
                                setDriverTypes(data);
                                // setLoading(false);
                            })
                            .catch(error => {
                                console.log(error)
                                if (error.response.status == 400) {
                                    navigate('/logout');
                                }
                            })
        }, []);



    const handleFilter = (type, value) => {
        const filtvalues = { ...filters };
        //refId is return error not exist in tasks table
        // filtvalues.refId = 7;
        
        switch (type) {
            case 'name':
                setName(value);
                if (value) {
                    filtvalues.name = value;
                } else {
                    delete filtvalues.name;
                }
                break;
            case 'status':
                setStatus(value);
                if (value) {
                    filtvalues.status = value;
                } else {
                    delete filtvalues.status;
                }
                break;
            case 'deliveryTypeId':
                setDeliveryTypeId(value);
                if (value) {
                    filtvalues.deliveryTypeId = value;
                } else {
                    delete filtvalues.deliveryTypeId;
                }
                break;
            case 'driverTypeId':
                setDriverTypeId(value);
                if (value) {
                    filtvalues.driverTypeId = value;
                } else {
                    delete filtvalues.driverTypeId;
                }
                break;
            default:
                break;
        }
        
        setFilters(filtvalues);
    }

    const handlePrevPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const handleNextPage = () => {
        if (page < totalPages) {
            setPage(page + 1);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Home" breadcrumbItem="Tasks" />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <br></br>
                                {successMsg ? <Alert style={{ margin: "25px" }} color="success">{successMsg}</Alert> : null}
                                <CardTitle>
                                    <Link to="/Tasks/add" >
                                        <button style={{ float: "right", marginRight: "20px" }} className="btn btn-sm btn-primary"><i className="dripicons-plus"></i> &nbsp;<Trans>Create</Trans></button>
                                    </Link>
                                </CardTitle>

                                <div style={{ margin: "25px" }}>
                                    <div className="row">
                                        <div className="form-group col-md-3 mt-2">
                                            <Label className="form-label"><Trans>Name</Trans></Label>
                                            <Input
                                                name="name"
                                                className="form-control"
                                                placeholder=""
                                                type="text"
                                                onChange={(e) => handleFilter('name', e.target.value)}
                                                onKeyDown={(e) => handleFilter('name', e.target.value)}
                                            ></Input>
                                        </div>
                                        <div className="form-group col-md-3 mt-2">
                                            <Label className="form-label"><Trans>Status</Trans></Label>
                                            <select name="status" value={status} className="form-control" onChange={(e) => handleFilter('status', e.target.value)}>
                                                <option value=''></option>
                                                <option value={1} ><Trans>Active</Trans></option>
                                                <option value={0} ><Trans>Non Active</Trans></option>
                                            </select>
                                        </div>
                                        <div className="form-group col-md-3 mt-2">
												<Label className="form-label"><Trans>Delivery Type</Trans></Label>
												<Select
													name="deliveryTypeId"
													options={deliveryTypes} 
													value={deliveryTypes.filter(el => el.value == deliveryTypeId)}
													className="form-control"
													isClearable={true}
													onChange={(e) => handleFilter('deliveryTypeId', e?.value || '')}
													/>
											</div>
                                        <div className="form-group col-md-3 mt-2">
												<Label className="form-label"><Trans>Driver Type</Trans></Label>
												<Select className="form-control" 
													name="driverTypeId"
													options={driverTypes} 
													value={driverTypes.filter(el => el.value == driverTypeId)}
													isClearable={true}
													onChange={(e) => handleFilter('driverTypeId', e?.value || '')} />															
											</div>
                                    </div>
                                </div>


                                <CardBody>
                                    <div className="table-responsive">
                                        <Table className="table table-striped table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th><Trans>ID</Trans></th>
                                                    <th><Trans>Name</Trans></th>
                                                    <th><Trans>Delivery Type</Trans></th>
                                                    <th><Trans>Driver Type</Trans></th>
                                                    <th><Trans>Task Ord</Trans></th>
                                                    <th><Trans>Status</Trans></th>
                                                    <th>#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? <tr><th colSpan={6} className="text-center"><Loader></Loader></th></tr> : null}
                                                {
                                                    Tasks.map((Task, index) => (
                                                        <tr key={index}>
                                                            <td>{Task.id}</td>
                                                            <td>{Task.name}</td>
                                                            <td>
                                                                {getTranslatedText(Task.deliveryType?.named?.title, Task.deliveryType?.name)}
                                                            </td>
                                                            <td>
                                                                {getTranslatedText(Task.driverType?.named?.title, Task.driverType?.name)}
                                                            </td>
                                                            <td>{Task.ord}</td>
                                                            <td>{(Task.status == 1) ? <Badge className="bg-success"><Trans>Active</Trans></Badge> : <Badge className="bg-error"><Trans>Not Active</Trans></Badge>}</td>
                                                            <td><Link to={`/tasks/edit/${Task.id}`}><button className="btn btn-sm btn-info"><i className="dripicons-pencil"></i> &nbsp;<Trans>Edit</Trans></button></Link> &nbsp;
                                                                <Link to={`/tasks/remove/${Task.id}`}><button className="btn btn-sm btn-danger" ><i className="dripicons-trash"></i> &nbsp;<Trans>Remove</Trans> </button></Link>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                    <br></br>
                                    <div className="text-center">
                                        {/* Pagination controls */}
                                        <button className="btn btn-sm btn-dark" onClick={handlePrevPage} disabled={page === 1}>
                                            <Trans>Previous</Trans>
                                        </button>&nbsp;
                                        <button className="btn btn-sm btn-dark" onClick={handleNextPage} disabled={page === totalPages}>
                                            <Trans>Next</Trans>
                                        </button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment >
    )
}

export default TaskList
